import { Helmet } from "react-helmet";

import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";

import { IExpenseListWithTotalRecord } from "../studio/Expenses/Lists";
import { IExpenseRecord } from "../../lib/types";
import { useToast } from "../../components/ui/use-toast";
import pb from "../../lib/pocketbase";
import Container from "../../components/Container";

import ExpenseOverview from "../../components/studio/expenses/Overview";

export default function PublicExpenseList() {
    const id = useParams().id;
    const [list, setList] = useState<IExpenseListWithTotalRecord>();
    const [expenses, setExpenses] = useState<IExpenseRecord[]>();
    const { toast } = useToast();
    async function load() {
        if (!id) return;
        const l: IExpenseListWithTotalRecord = await pb.collection("expenseList").getOne(id);

        const exp: IExpenseRecord[] = await pb.collection("expense").getFullList({
            filter: `list="${id}"`,
            expand: `type`,
            sort: "-date"
        });

        l.total = exp.reduce((total, expense) => {
            if (expense.income) return total + expense.amount * expense.price;
            else return total - expense.amount * expense.price;
        }, 0);

        setExpenses(exp);
        setList(l);
    }

    useEffect(() => {
        load();
    }, []);
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Expenses — List</title>
            </Helmet>
            <Container variant={"large"} className="my-8 md:my-16">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <h2 className="text-2xl font-medium">{list?.name}</h2>
                    </div>
                </div>
                <ExpenseOverview editable={false} expenses={expenses} reload={() => load()} />
            </Container>
        </>
    );
}
